import { HPSobBusinessUnits } from 'legacy/lut/classes/models/partner360/ELT/financialData/hpSob/HPSobBusinessUnits'
import { categoriesForBU } from 'legacy/lut/classes/models/partner360/ELT/financialData/hpSob/hpSobCategories'
import {
  IHpSob,
  IHpSobCategoriesData,
} from 'legacy/lut/classes/models/partner360/ELT/financialData/hpSob/IHpSob'
import { IHpSobSnapshot } from 'legacy/lut/classes/models/partner360/ELT/financialData/hpSob/IHpSobSnapshot'

import { formHpSobFromFinancialData } from './formHpSobFromFinancialData'

export const getHpSobInitialData = (initialData?: IHpSobSnapshot[]): IHpSob[] => {
  if (!initialData) {
    return (Object.keys(HPSobBusinessUnits) as Array<keyof typeof HPSobBusinessUnits>).map(
      (key) => {
        const categoriesData: IHpSobCategoriesData[] = categoriesForBU[HPSobBusinessUnits[key]].map(
          (category: string) => ({
            Category: category,
            SobActuals22Q1: 0,
            SobActuals22Q2: 0,
            SobActuals22Q3: 0,
            SobActuals22Q4: 0,
            SobActuals23Q1: 0,
            SobActuals23Q2: 0,
            SobActuals23Q3: 0,
            SobActuals23Q4: 0,
          })
        )
        const data: IHpSob = {
          BusinessUnit: HPSobBusinessUnits[key],
          CategoriesData: categoriesData,
        }
        return data
      }
    )
  }

  return formHpSobFromFinancialData(initialData)
}
